import { FC, useState, useEffect } from 'react';
import axios, { AxiosResponse } from 'axios';
import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select
} from "@material-ui/core";

import { useStyles } from './style';
import { COMPANY_SELECTOR_LABEL } from "../../pages/successpay/successPay.const";
import { COMPANY_LIST } from '../../../utils/api.config.consts';
import { api, base_url } from '../../../utils/env';
import ReactNotification, { DANGER, ERROR, FETCH_ERROR } from '../../../utils/ReactNotification.config';

import "../../css/EnableSuccessPay.css";

interface CompanyListSelectorProps {
    selectCompanyID: (data: string) => void,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    masterID: string | null,
    companyID: string | null
}
interface CompanyListOptionsArray {
    companyId: string,
    companyName: string
}

const CompanyListSelector: FC<CompanyListSelectorProps> = ({ selectCompanyID, setLoading, masterID, companyID }: CompanyListSelectorProps) => {

    const [data, setData] = useState<CompanyListOptionsArray[]>([])
    const classes = useStyles();

    useEffect(() => {
        const token: string = "Bearer ".concat(localStorage.getItem("token") as string);
        axios.defaults.headers.common['Auth'] = token;
    }, []);

    const handleChange = (event: React.ChangeEvent<any>) => {
        selectCompanyID(event.target.value as string);
    };

    const getCompanies = () => {
        setLoading(true);
        axios
            .get(`${base_url}${api}/${COMPANY_LIST}/list`)
            .then((response: AxiosResponse<any>) => {
                setLoading(false);
                setData(response.data.companyDetailsList);
                if (response.data.companyDetailsList.length === 1) {
                    selectCompanyID(response.data.companyDetailsList[0].companyId)

                }
            })
            .catch(() => {
                setLoading(false);
                ReactNotification.showNotification(ERROR, FETCH_ERROR, DANGER);
                setData([]);
            });
    }

    useEffect(() => {
        getCompanies();
    }, [])

    return (
        <section className="enable-success-pay-container">
            <div className=" box-shadow  custom-card-enable-success-pay">
                <Grid container direction="row" >
                    <span className="title-label">{COMPANY_SELECTOR_LABEL}</span>
                </Grid>
                <div className="grid-margin">
                    <Grid container direction="row" md={5} xs={12}>
                        <FormControl
                            className={classes.formControl}
                            variant="outlined"
                            size="small"
                        >
                            <InputLabel id="company">{COMPANY_SELECTOR_LABEL}</InputLabel>
                            <Select
                                labelId="company"
                                id="company-select-input"
                                label={COMPANY_SELECTOR_LABEL}
                                displayEmpty
                                onChange={handleChange}
                                value={companyID}
                                inputProps={{ 'aria-label': COMPANY_SELECTOR_LABEL, className: classes.input }}
                            >
                                <MenuItem value={'default'}>Select Company</MenuItem>

                                {data && data.length > 0 &&
                                    data.map(
                                        (objCompany: { companyId: string; companyName: string; }) => {
                                            return (
                                                <MenuItem value={objCompany.companyId}>
                                                    {`${objCompany.companyId}-${objCompany.companyName}`}
                                                </MenuItem>
                                            )
                                        })

                                }
                                {/* {data && data.length > 0 && data.length === 1 &&
                                    <MenuItem selected value={data[0].companyId}>
                                        {`${data[0].companyId}-${data[0].companyName}`}
                                    </MenuItem>
                                } */}
                            </Select>
                        </FormControl>
                    </Grid>
                </div>
            </div>
        </section>
    )
}

export default CompanyListSelector